import { useState, useEffect } from 'react';

// Função auxiliar para buscar o elemento pelo ID
const getElementById = (id: string | null) => document.getElementById(id || '');

const useChangeTextById = (elementId: string, newText: string,) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    // Busca o elemento pelo ID
    const element = getElementById(elementId);
    // Verifica se o elemento foi encontrado antes de tentar alterar o texto
    if (element) {
      // Altera o texto do elemento
      setDisabled(!disabled);
      element.textContent = newText;
      element.disabled = !disabled;
    } else {
      console.error(`Elemento com ID ${elementId} não encontrado.`);
    }
  }, [elementId, newText]);
};

export default useChangeTextById;
